export default __webpack_public_path__ + "static/media/li.8962ced7.svg";